import { Box, Typography } from "@mui/material";

const NewFormPage = () => {
  return (
    <Box sx={{ pt: "140px", px: 3 }}>
      <Typography variant="h4" fontWeight={600}>
        New Application Form
      </Typography>

      {/* Your form goes here */}
    </Box>
  );
};

export default NewFormPage;
